import { useState } from "react";
import { convertToNumber } from "grandus-lib/utils";
import { Slider } from "antd";
import {
  get,
  map,
  isEmpty,
  sortBy,
  head,
  last,
  isNumber,
  isNaN,
  find,
} from "lodash";

const CategoryElementSlider = ({
  parameter,
  handleChange,
  selected,
  options = {},
}) => {
  const {
    id: parameterId,
    name: parameterName,
    urlTitle: parameterTitle,
  } = parameter;

  const parameterValues = get(parameter, "values", []);
  const { styles = {}, headline = "" } = options;

  let slider = {};
  slider.marks = {};
  slider.sliderValues = [];
  slider.selected = [];

  map(sortBy(parameterValues, ["urlName"]), (value) => {
    const number = convertToNumber(value?.value);

    if (!(isNumber(number) && !isNaN(number))) {
      return;
    }

    slider.marks[number] = {
      style: {
        display: "none",
      },
      label: value?.value,
    };

    if (get(value, "selected", false)) {
      slider.selected.push(number);
    }

    slider.sliderValues.push(number);
  });

  slider.sliderValues = sortBy(slider.sliderValues);
  // slider.marks = sortBy(slider.marks, mark => mark.number);
  slider.min = head(slider.sliderValues);
  slider.max = last(slider.sliderValues);

  const [sliderValues, setSliderValues] = useState({
    min: head(slider.sliderValues) ? head(slider.sliderValues) : slider.min,
    max: last(slider.selected) ? last(slider.selected) : slider.max,
  });

  if (isEmpty(parameterValues)) {
    return "";
  }

  return (
    <div className={styles?.parameter}>
      {headline ? (
        headline
      ) : (
        <h3 className={styles?.headline}>{parameterName}</h3>
      )}
      <Slider
        style={{ marginBottom: 0 }}
        range
        min={slider.min}
        max={slider.max}
        defaultValue={
          isEmpty(slider.selected)
            ? [slider.min, slider.max]
            : [head(slider.selected), last(slider.selected)]
        }
        // value={[slider.min, slider.max]}
        marks={slider.marks}
        allowCross={false}
        dotStyle={{ display: "none" }}
        step={null}
        onChange={(values) => {
          setSliderValues({ min: head(values), max: last(values) });
        }}
        onAfterChange={(values) => {
          const selectedMin = head(values);
          const selectedMax = last(values);

          setSliderValues({ min: selectedMin, max: selectedMax });

          const selectedMinObj = find(
            parameterValues,
            (parameterValue) =>
              convertToNumber(parameterValue.value) === selectedMin
          );
          const selectedMaxObj = find(
            parameterValues,
            (parameterValue) =>
              convertToNumber(parameterValue.value) === selectedMax
          );

          handleChange(parameterTitle, [
            get(selectedMinObj, "urlName", encodeURIComponent(selectedMin)),
            get(selectedMaxObj, "urlName", encodeURIComponent(selectedMax)),
          ]);
        }}
      />
      <div className={styles.spaceWrapper}>
        <span>
          {get(slider, ["marks", sliderValues.min, "label"], sliderValues.min)}
        </span>
        <span>
          {get(slider, ["marks", sliderValues.max, "label"], sliderValues.max)}
        </span>
      </div>
    </div>
  );
};

export default CategoryElementSlider;
